/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The item's processing outcome.
 */
export const SkillSuggestionApprovalItemOutcome = {
  Applied: "applied",
  Superseded: "superseded",
  Conflict: "conflict",
  Failed: "failed",
} as const;
/**
 * The item's processing outcome.
 */
export type SkillSuggestionApprovalItemOutcome = OpenEnum<
  typeof SkillSuggestionApprovalItemOutcome
>;

/**
 * The result of one item in a bulk suggestion approval.
 */
export type SkillSuggestionApprovalItem = {
  /**
   * A safe explanation for a conflict or failure.
   */
  message?: string | undefined;
  /**
   * The item's processing outcome.
   */
  outcome: SkillSuggestionApprovalItemOutcome;
  /**
   * The created version for an applied item.
   */
  resultingVersionId?: string | undefined;
  /**
   * The user-facing skill name.
   */
  skillDisplayName: string;
  /**
   * The targeted skill ID.
   */
  skillId: string;
  /**
   * The canonical skill name.
   */
  skillName: string;
  /**
   * The suggestion ID.
   */
  suggestionId: string;
};

/** @internal */
export const SkillSuggestionApprovalItemOutcome$inboundSchema: z.ZodMiniType<
  SkillSuggestionApprovalItemOutcome,
  unknown
> = openEnums.inboundSchema(SkillSuggestionApprovalItemOutcome);

/** @internal */
export const SkillSuggestionApprovalItem$inboundSchema: z.ZodMiniType<
  SkillSuggestionApprovalItem,
  unknown
> = z.pipe(
  z.object({
    message: z.optional(z.string()),
    outcome: SkillSuggestionApprovalItemOutcome$inboundSchema,
    resulting_version_id: z.optional(z.string()),
    skill_display_name: z.string(),
    skill_id: z.string(),
    skill_name: z.string(),
    suggestion_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "resulting_version_id": "resultingVersionId",
      "skill_display_name": "skillDisplayName",
      "skill_id": "skillId",
      "skill_name": "skillName",
      "suggestion_id": "suggestionId",
    });
  }),
);

export function skillSuggestionApprovalItemFromJSON(
  jsonString: string,
): SafeParseResult<SkillSuggestionApprovalItem, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillSuggestionApprovalItem$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillSuggestionApprovalItem' from JSON`,
  );
}
